<app-adminav></app-adminav>
<div class="container">
    <div class="col-lg-12 mt-5">
        <h3>Lista de clientes activos</h3>
        <hr>
        <table class="table table-hover mt-3">
            <thead class="thead-dark">
                <tr>
                    <th scope="col">Nombre</th>
                    <th scope="col">Detalle</th>
                </tr>
            </thead>
            <tbody class="text-left">
                <tr *ngFor="let cliente of lista ">
                    <td>{{cliente.email}}</td>
                    <td><button *ngIf="cliente.datos" class="btn btn-info" (click)="datosCliente(cliente.datos)" data-toggle="modal" data-target="#clientData">Datos</button></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<!-- Modal -->
<div *ngIf="datosCliente" class="modal fade" id="clientData" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Datos del cliente:</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <h5>Nombre: <b>{{nombre | titlecase}}</b></h5>
        <h5>Teléfono: <b>{{telefono}}</b></h5>
        <h5>Dirección: <b>{{direccion}}</b></h5>
        <h5>Ciudad: <b>{{ciudad |titlecase}}</b></h5>
        <h5>Departamento: <b>{{departamento | titlecase}}</b></h5>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>
